import { combineReducers } from "redux";
import login from './login'
import signup from './signup'

const primaryReducer = combineReducers({
  login,
  signup
});

export default primaryReducer;